import { Component, OnInit, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AppUser, Model, UserAuthService, UserManagementComponent } from '@definitiv-packages/angular-dba-library';

@Component({
  selector: 'app-user-main-view',
  templateUrl: './user-main-view.component.html',
  styleUrls: ['./user-main-view.component.scss'],
  standalone: false
})
export class UserMainViewComponent implements OnInit, AfterViewInit {
  public electronicID: boolean = false;
  public loading: boolean = false;
  public selectedUser: AppUser | null = null;
  @Output() public userDelete: EventEmitter<void> = new EventEmitter();

  @ViewChild('userManagement') userManagement?: UserManagementComponent;
  constructor(

    private userAuthService: UserAuthService,
    private dialog: MatDialog
  ) { }
  ngAfterViewInit(): void {


  }

  public ngOnInit(): void {

  }

  public OnUserDelete() {
    const appUser = this.selectedUser;
    if (!appUser) return;

    this.loading = true;
    // this.vertragsService.CheckBenutzerBevorLoschen(appUser.UserID).then(res=>{
    //     var msg = "";
    //     var benutzerName = (appUser.FirstName!='' && appUser.LastName!='')?appUser.FirstName +" "+ appUser.LastName:appUser.Email;
    //     msg  = "<p>Der Benutzer " + benutzerName +":</p>";
    //     Object.keys(res).map((key : any) => ({ key, value: `${res[key]}` })).forEach(elem=>{
    //       if(elem.key == "Vertraege" && elem.value.length>0){msg += "<div>hat den exklusiven Zugriff auf <b>"+elem.value.length+ "</b> Verträge</div>";}
    //       if(elem.key == "Individuelle" && elem.value.length>0){msg += "<div>ist Empfänger von  <b>"+elem.value.length+ "</b> individuelle Benachrichtigungen</div>";}            
    //       if(elem.key == "Benachrichtigungen" && elem.value.length>0){msg += "<div>ist Benachrichtigungsempfänger in <b>"+elem.value.length+ "</b> Verträge</div>";}
    //       if(elem.key == "Eskalation" && elem.value.length>0){msg += "<div>ist Eskalationsempfänger in <b>"+elem.value.length+ "</b> Verträge</div>";}            
    //       if(elem.key == "Workflow" && elem.value.length>0){msg += "<div>ist Workflow-Freigeber in <b>"+elem.value.length+ "</b> Verträge</div>";}            
    //       if(elem.key == "Workflowtemplate" && elem.value.length>0){msg += "<div>ist Freigeber in <b>"+elem.value.length+ "</b> Workflowvorlagen</div>";}            

    //       this.loading = false;
    //     });
    //      msg = "<br /><p>Wählen Sie einen Benutzer, der diesen Benutzer ersetzen soll..</p>";

    //     var data = new UserMainExportData();
    //     data.appUser = appUser;
    //     data.Title = "Benutzer löschen";
    //     data.Text = msg;
    //     const dialogRef = this.dialog.open(BenutzerDialogComponent, { data});
    //     var subscription = dialogRef.afterClosed().subscribe((result) => {                        
    //         if(!result) return;
    //         this.loading = true;
    //         this.vertragsService.VertragBenutzerUerbtragen(appUser,result).then(result=>{   
    //         this.loading = false;            
    //           BuildDeleteDataPromise<AppUser>([appUser], (element) => { return this.userAuthService.DeleteUser(element) }).then( () => {
    //             this.loading = false;
    //             this.userManagement?.LoadDataMain();
    //           });                        
    //         });

    //         subscription.unsubscribe();
    //     });            
    // });

  }
}
export class UserMainExportData extends Model {
  public appUser: AppUser | null = null;
  public Title: string | null = null;
  public Text: string | null = null;
}